import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "work-cost-center-container" }
const _hoisted_2 = { class: "work-center-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Add Work Center", -1)
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "workCenterName" }, "Name:", -1)
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "workCenterDescription" }, "Description:", -1)
const _hoisted_8 = { class: "cost-center-section" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Add Cost Center", -1)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "costCenterName" }, "Name:", -1)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "costCenterDescription" }, "Description:", -1)

import { ref } from 'vue';
import { postToUrl } from '@/api/api'; // Adjust the import path as needed
import { WorkCenter, CostCenter } from './types/Ops';




export default /*#__PURE__*/_defineComponent({
  __name: 'WorkAndCostCenter',
  setup(__props) {

const initialWorkCenterState = { name: '', description: '' };
const initialCostCenterState = { name: '', description: '' };

const workCenter = ref<WorkCenter>({ ...initialWorkCenterState });
const costCenter = ref<CostCenter>({ ...initialCostCenterState });

const saveWorkCenter = async () => {
  try {
    const response = await postToUrl<WorkCenter>('/ops/api/workcenters/', workCenter.value);
    alert('Work Center saved successfully!');
    workCenter.value = { ...initialWorkCenterState }; // Resetting the form
  } catch (error) {
    alert('Failed to save Work Center.');
  }
};

const saveCostCenter = async () => {
  try {
    const response = await postToUrl<CostCenter>('/ops/api/costcenters/', costCenter.value);
    alert('Cost Center saved successfully!');
    costCenter.value = { ...initialCostCenterState }; // Resetting the form
  } catch (error) {
    alert('Failed to save Cost Center.');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          id: "workCenterName",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((workCenter.value.name) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, workCenter.value.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("textarea", {
          id: "workCenterDescription",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((workCenter.value.description) = $event)),
          rows: "4"
        }, null, 512), [
          [_vModelText, workCenter.value.description]
        ])
      ]),
      _createElementVNode("button", { onClick: saveWorkCenter }, "Save Work Center")
    ]),
    _createElementVNode("section", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          id: "costCenterName",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((costCenter.value.name) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, costCenter.value.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("textarea", {
          id: "costCenterDescription",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((costCenter.value.description) = $event)),
          rows: "4"
        }, null, 512), [
          [_vModelText, costCenter.value.description]
        ])
      ]),
      _createElementVNode("button", { onClick: saveCostCenter }, "Save Cost Center")
    ])
  ]))
}
}

})